export class SettingsLogoutConfigurationService {
  private _logoutFn: (args?: any) => any;

  constructor() {
    this._logoutFn = () => false;
  }

  get logoutMetod() {
    return this._logoutFn;
  }

  set logoutMethod(fn: any) {
    this._logoutFn = fn;
  }

  invokeLogout(...args: any[]): any {
    this._logoutFn(args);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/services/settings_logout_configuration_service.ts